export default {

    //API_BASE_URL : 'http://localhost:8086',
    API_BASE_URL : 'https://api.uec.fsi.ulaval.ca'

}